<template>
  <el-dialog title="打印" :visible.sync="dialogPrintVisible" append-to-body @closed="closePrint" v-if="visiblePrint">
    <el-select v-model="printId" placeholder="请选择" @change="choosePrint" style="margin-bottom: 20px">
      <el-option v-for="item in printList" :key="item.id"
        :label="`${item.name} (${item.paperWidth}mm*${item.paperHeight}mm)`" :value="item.id">
      </el-option>
    </el-select> 
    <!--    <el-button type="primary" style="margin-left: 50px" v-print="'#printAll'" >打印</el-button>-->
    <el-button type="primary" style="margin-left: 50px" @click="printbatch">打印</el-button>

    <!-- <div id="printAll"> -->
      <div v-for="(item,index) in printDataList" :key="index" :id="'warehousePrintItem'+index"
        :style="`width: ${paperWidth}mm ;height: ${paperHeight-0.3}mm;page-break-after: always;display:flex;align-items: center;`">
        <div
          :style="`width: ${paperWidth-4}mm ;height: ${paperHeight-4}mm;border:0.4mm black solid;page-break-after: always;margin:0 auto;`">
          <vue-qr :size="1000" :margin="0" :auto-color="true" :dot-scale="1" :text="item.stackHandle"
            class="codeImage"
            :style="`width: ${codeWidth}mm;height: ${codeWidth}mm;display: block;margin: 0 auto;margin-top:1mm;`" />
          <div :style="`font-size: ${codeWidth*0.12}mm;text-align: center;`">{{item.stackName}}</div>
        </div>
      </div>
    <!-- </div> -->
  </el-dialog>
</template>
<script>
  import { selectAllPrintList } from '@/api/storeCodePrint.js'
  import { fetchWarehouseList } from '@/api/storeStack.js'
  import print from 'vue-print-nb'
  import VueQr from 'vue-qr'
  import { codeUrl } from '@/utils/constant'
  export default {
    directives: { print },
    data() {
      return {
        codeUrl: codeUrl,
        barcode_option: {
          displayValue: false,
        },
        userInfo: '',
        companyName: '',
        codeWidth: 50,
        classHeight: 6,
        list: [],
        dialogPrintVisible: false,
        printId: '',
        printList: [],
        paperWidth: 70,
        paperHeight: 30,
        printDataList: [],
        isAll: false,
        printData: {},
        visiblePrint: false,
        marginsWidth: 6,
        marginsHeight: 4,
        warehouseId: null
      }
    },
    components: { VueQr },
    props: {},
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }
    },
    mounted() {
      this.getAllPrint()
    },
    methods: {
      init(parentId, warehouseId, type) {
        this.getPrintData(parentId, warehouseId)
      },
      initSize() {
        this.codeWidth = parseInt((this.paperWidth - this.marginsWidth) * 0.8)
        if (this.codeWidth > (this.paperHeight - this.marginsHeight) * 0.8) {
          this.codeWidth = parseInt((this.paperHeight - this.marginsHeight) * 0.8)
        }
        // this.printDataList.forEach(item => {
        //   var lineHeight = parseInt((this.paperHeight - 14) / (item.storeCodeDetailVos.length));
        //   if (lineHeight > 0) {
        //     item.classHeight = lineHeight
        //   }
        // })
      },
      choosePrint() {
        // this.timer = new Date().getTime();
        let fe = this.printList.filter(item => {
          return item.id == this.printId
        })
        if (fe) {
          this.paperWidth = fe[0].paperWidth
          this.paperHeight = fe[0].paperHeight
        }
        this.initSize()
      },
      getAllPrint() {

        selectAllPrintList().then(res => {
          this.printList = res.data
          if (this.printList && this.printList.length > 0) {
            this.printId = this.printList[0].id
            this.choosePrint()
          }
        })
      },
      getPrintData(parentId, warehouseId) {
        console.log('parentId', parentId);
        console.log('warehouseId', warehouseId);
        this.warehouseId = warehouseId
        fetchWarehouseList({id:warehouseId}).then(res => {
          this.printDataList = res.data
          this.initSize()
          this.dialogPrintVisible = true
        })

      },
      printbatch() {
        const printStyle = `<style>@media print{body{margin: 0; padding: 0;}}</style>`;
        var newWin = window.open(""); //新打开一个空窗口
        console.log('printDataList', this.printDataList)
        for (var i = 0; i < this.printDataList.length; i++) {
          var imageToPrint = document.getElementById("warehousePrintItem" + i); //获取需要打印的内容
          console.log('imageToPrint', imageToPrint)
          newWin.document.write(imageToPrint.outerHTML); //将需要打印的内容添加进新的窗口
        }
        newWin.document.head.innerHTML = printStyle; //给打印的内容加上样式
        newWin.document.close(); //在IE浏览器中使用必须添加这一句
        newWin.focus(); //在IE浏览器中使用必须添加这一句
        setTimeout(function () {
          newWin.print(); //打印
          newWin.close(); //关闭窗口
        }, 100);
      },
      closePrint() {
        this.visiblePrint = false
      }
    }
  }
</script>
<style scoped>
  @page {
    size: auto;
    margin: 0mm;
  }
</style>